const authorizedDealer = {
  authorizedDealer: {
    dealerId: 'Autorisierter Subunternehmer',
    city: 'Stadt',
    state: 'Staat',
    country: 'Land',
    noDealer: '** Kein autorisierter Subunternehmer verfügbar **',
    heading: 'Autorisierter Subunternehmer',
    addDealerButton: '+ Autorisierten Subunternehmer hinzufügen',
    cancel: 'ABBRECHEN',
    addSubcontractor: 'SUBUNTERNEHMER HINZUFÜGEN',
    searchContractor: 'NACH SUBUNTERNEHMER SUCHEN',
    show: 'Affiche',
    to: 'zu',
    of: 'von',
    delete: 'Löschen',
    name: 'Name',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    status: 'Status',
    footer: 'Autorisierter Subunternehmer'
  }
};

export default authorizedDealer;
